import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// Segmented "Hourly / Daily" switch used above the battery and PCS charts
const PlotModeToggle = ({
  value,
  onChange,
  options = [
    { value: "hourly", label: "Hourly" },
    { value: "daily", label: "Daily" },
  ],
}) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    size="small"
    onChange={(_, mode) => mode && onChange(mode)}
    aria-label="Plot resolution"
    sx={{
      backgroundColor: "var(--c-muted)",
      borderRadius: "10px",
      p: 0.25,
      "& .MuiToggleButton-root": {
        border: "none",
        borderRadius: "8px !important",
        px: 1.5,
        py: 0.25,
        fontSize: 12,
        fontWeight: 600,
        textTransform: "none",
        color: "var(--c-text-muted)",
      },
      "& .MuiToggleButton-root.Mui-selected": {
        backgroundColor: "var(--c-surface)",
        color: "var(--c-brand)",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
      },
      "& .MuiToggleButton-root.Mui-selected:hover": { backgroundColor: "var(--c-surface)" },
    }}
  >
    {options.map(option => (
      <ToggleButton key={option.value} value={option.value}>{option.label}</ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default PlotModeToggle;
